import React, { useState, useEffect, Fragment } from "react";
import { NavLink } from "react-router-dom";
import Table from "../Base/Table";
import { getNotificationsForFleet } from "../Utils/Fleet";
import { getNotificationsForUser } from "../Utils/User";
var moment = require("moment");

/**
 * Notifications Table Component
 */
const NotificationsTable = ({ companyId, fleetId, userId }) => {
  const { notifications } = userId ? getNotificationsForUser(userId) : getNotificationsForFleet(fleetId, companyId);

  var columns = [];
  if (!userId) {
    columns.push({
      Header: "Name",
      accessor: "userName",
      headerClassName: "left"
    });
  }
  columns.push(
    {
      Header: "Time Sent",
      id: "date",
      headerClassName: "left",
      accessor: d => {
        return moment(d.date).format("MM/DD/YY h:mm A");
      }
    },
    {
      Header: "Energy",
      accessor: "energyLevel",
      className: "center"
    }
  );
  var notificationData = [];
  notifications.forEach(notification => notificationData.push(notification.data()));

  return (
    <Fragment>
      <h2>Driver Notifications</h2>
      <Table data={notificationData} columns={columns} pageSize={notificationData.length} />
    </Fragment>
  );
};

export default NotificationsTable;
